import gql from 'graphql-tag'

export const GET_SUPPORTED_CURRENCIES = gql`
  query getSupportedCurrencies {
    supportedCurrencies {
      supportedCurrencies {
        code
        symbol
        name
      }
    }
  }
`
